import { z } from 'zod';
import { TypeOfAPIError, TypeOfAPIResponse } from '@ninja/api-client';
import { APIFactoryOptions, factory } from '../../config';

const responseSchema = z.object({
	facilityTypes: z.array(z.number()),
	cities: z.array(z.object({ id: z.number(), name: z.string(), countryId: z.number() })),
});

const getNetworkSearchFilters = (options: APIFactoryOptions) =>
	factory(options).createAPIDefinition({
		url: '/Quote/networksearchfilters',
		method: 'POST',
		responseSchema: responseSchema,
		requestSchema: z.null().nullish(),
		requestParameters: { planId: ['required', 'number'] },
		errorCodes: ['NoNetworkAvailable'],
	});

export default getNetworkSearchFilters;

export type NetworkSearchFilterResponse = TypeOfAPIResponse<ReturnType<typeof getNetworkSearchFilters>>;

export type NetworkSearchFilterError = TypeOfAPIError<ReturnType<typeof getNetworkSearchFilters>>;
